module.exports = __webpack_public_path__ + "static/amarok-4518a167cc7db2427f2a7f1dce9040bb.png";